module.exports = __webpack_public_path__ + "static/media/bar-chart-inactive.5197d479.svg";